export default {
    SET_MEMBER: "SET_MEMBER",
    GET_MEMBER: "GET_MEMBER",
    UPDATE_MEMBER: "UPDATE_MEMBER",
    GET_ONE_MEMBER: "GET_ONE_MEMBER",
    CHANGE_PAGE_NUMBER: 'member/CHANGE_PAGE_NUMBER',
    CHANGE_PAGE_SIZE: 'member/CHANGE_PAGE_SIZE'
}